import './css/Neex.css';

function Neex() {
    return (
        <div id='neex'>
            <div className='container'>
                <div className='neex p-2'>
                    <div className='mb-5' id='neex-top'>
                        <span id='neex-title'><span>NE</span>xt level <span>EX</span>perts</span><br></br>
                        <span className='mb-2'>次世代IT技術のエキスパート集団</span>
                    </div>
                    <div className='align-items-center' id='box'>
                        <span className='text-white' id='text'>
                            <p>エンジニアファーストの会社です。</p>

                            <p>エンジニア本当にやりたいこと、働き方を実現。<br/>
                            働きに対する報酬を最大限に、売り上げの約90%をエンジニアに還元。</p>

                            <p>現役エンジニアである社長が、自身の経験をもとに、<br/>
                            エンジニアにとって最高の環境・条件で働けるような会社へ<br/>
                            常に前進し続けます。</p>

                            <p>ご自身の単価売上や運営に関するコストを公開します。<br/>
                            営業や中間管理職などを可能な限り削減し、エンジニアに還元。<br/>
                            自身の契約金額や条件を確認することができます。<br/>
                            業界トップクラスの技術者が多数在籍。<br/>
                            離職率が非常に低いのが特徴です。</p>

                            <p>常にみんなで改善している会社です。</p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Neex;
